import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersSelectorListComponent } from './users-selector-list/users-selector-list.component';
import { MaterialModule } from '@app/material/material.module';
import { UsersSelectorService } from './users-selector.service';
import { CoreModule } from '@app/core';
import { UsersSelectorComponent } from './users-selector.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared';



@NgModule({
  declarations: [
    UsersSelectorListComponent,
    UsersSelectorComponent
  ],
  exports: [
    UsersSelectorComponent
  ],
  imports: [
    CommonModule, 
    MaterialModule,
    CoreModule,
    FormsModule, 
    SharedModule
  ], 
  providers: [UsersSelectorService]
})
export class UsersSelectorModule { }
